import React from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, PlayCircle } from "lucide-react";
import { Fund } from "@/types/Fund";

interface ValidationRulesHeaderProps {
  selectedFund: Fund;
  isValidating: boolean;
  isLoading: boolean;
  validationRulesCount: number;
  onValidateRules: () => void;
  onRefreshRules: () => void;
}

export const ValidationRulesHeader: React.FC<ValidationRulesHeaderProps> = ({
  selectedFund,
  isValidating,
  isLoading,
  validationRulesCount,
  onValidateRules,
  onRefreshRules
}) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Validation Rules</h1>
        <p className="text-muted-foreground mt-2">
          Configure and manage validation rules for <span className="font-medium">{selectedFund.name}</span>
        </p>
      </div>
      <div className="flex items-center gap-3">
        <Button
          onClick={onValidateRules}
          disabled={isValidating || validationRulesCount === 0}
          variant="outline"
          className="flex items-center gap-2"
        >
          <PlayCircle className={`h-4 w-4 ${isValidating ? 'animate-spin' : ''}`} />
          {isValidating ? 'Validating...' : 'Run Validation'}
        </Button>
        <Button
          onClick={onRefreshRules}
          disabled={isLoading}
          variant="outline"
          className="flex items-center gap-2"
        >
          <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
      </div>
    </div>
  );
}; 